/*** IMPORTS FROM imports-loader ***/
var angular = require("angular");

require('./angular-messages');
module.exports = 'ngMessages';




//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-messages/index.js
// module id = 25
// module chunks = 24